<template>
    <v-card class="dialog-card">
        <h2 class="dialog-card__header">Saving community</h2>
        <CommunityName
          :name="name"
          :check_name_availibility=true
          :namespace="namespace"
          :available_namespaces="available_namespaces"
          @confirm="confirm($event)"/>
    </v-card>
</template>

<script>
    import CommunityName from "./CommunityName"
    import CommunityService from "../../services/community.service"

    export default {
        name: "SaveCommunity",
        props: {
            query: String,
            initial_namespace: String,
            initial_name: String
        },
        components: {CommunityName},
        data: () => ({
            name: "",
            namespace: String,
            available_namespaces: [],
        }),
        methods: {
            confirm(community_name_obj) {
                this.$emit("confirm", {
                    namespace: community_name_obj.namespace,
                    name: community_name_obj.name,
                    query: this.query,
                })
            },
            cancel() {
                this.$emit("cancel")
            },
        },
        mounted() {
            this.namespace = this.initial_namespace || "";
            this.name = this.initial_name;
            let cs = new CommunityService();
            cs.getAvailableDomains().then(d => {
              this.available_namespaces = d.filter(ns => ns.writable)
              .map(ns => {
                  return ns.name;
              });
              if (!this.namespace && this.available_namespaces.length) {
                this.namespace = this.available_namespaces[0];
              }
            })
        },
        watch: {}
    }
</script>
